var map = {
	"./Header": 1183,
	"./Header.tsx": 1183,
	"./Hello": 1206,
	"./Hello.js": 1206,
	"./collections/approveModal": 1052,
	"./collections/approveModal.tsx": 1052,
	"./collections/create": 1349,
	"./collections/create.tsx": 1349,
	"./collections/like": 1350,
	"./collections/like.tsx": 1350,
	"./common/header": 1351,
	"./common/header.tsx": 1351,
	"./common/modal": 1107,
	"./common/modal.tsx": 1107,
	"./myEthWallet/connect": 1352,
	"./myEthWallet/connect.tsx": 1352,
	"./walletConnect/walletConnect": 1353,
	"./walletConnect/walletConnect.tsx": 1353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1359;